import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FactCheckResolution, LlmAction, SentenceIdPair } from './ai-action.types'

@Injectable({
  providedIn: 'root',
})
export class AiActionService {
  private httpClient = inject(HttpClient)

  sendStreamingRequest(callId: number, action: LlmAction, sentenceIdPairs: SentenceIdPair[], selectionContent: string, templateItemIds: number[]): EventSource {
    const queryParams = new URLSearchParams({
      action,
      sentenceIdPairs: JSON.stringify(sentenceIdPairs),
      selectionContent,
      templateItemIds: JSON.stringify(templateItemIds),
    }).toString()

    return new EventSource(`/api/calls/${callId}/llm-live-async?${queryParams}`, {
      withCredentials: true,
    })
  }

  sendSyncRequest(
    callId: number,
    action: LlmAction,
    sentenceIdPairs: SentenceIdPair[],
    selectionContent: string,
    templateItemIds: number[]
  ): Observable<FactCheckResolution[]> {
    return this.httpClient.post<FactCheckResolution[]>(`/api/calls/${callId}/llm-live-sync`, {
      action,
      sentenceIdPairs,
      selectionContent,
      templateItemIds,
    })
  }
}
